/**
 * How a human reaches the artwork.
 *
 * Deliberately independent of the visual recipe. A recipe says what is drawn; an
 * interaction mode says what the player's presses *mean*. Every combination is
 * valid, and keeping them orthogonal is what lets the same visual configuration
 * be played for score, played for the picture, or watched with no player at all.
 *
 * `ART` is the one worth being careful about. It must not be implemented as
 * "SCORE with the numbers hidden", and a miss must not simply degrade the image:
 * the point is that an inaccurate press produces a *different* mark, not a worse
 * one. Splashed ink and torn geometry are outcomes, not penalties.
 *
 * Kept as a union with a guard rather than a TypeScript `enum` so that added
 * modes — `ZEN`, `CHAOS`, `PERFORMANCE`, `INSTALLATION` — cost one entry here
 * and nothing at the call sites that switch on it.
 */

export const INTERACTION_MODES = ['SCORE', 'ART', 'AUTO'] as const;

export type InteractionMode = (typeof INTERACTION_MODES)[number];

export function isInteractionMode(value: string): value is InteractionMode {
  return (INTERACTION_MODES as readonly string[]).includes(value);
}
